import detailDefault from '../../detailDefault';

export default class detailaon_portal_messages_visibility extends detailDefault {
    load(sAction, data) {
        // call immediately after detailView is load
        this.updateVisibilityRelations(sAction, data.prefix);
    }
    update(sAction, data) {
        // call immediately after detailView field is update
        if (['contacts_aon_portal_messages_visibility_1contacts_ida', 'accounts_aon_portal_messages_visibility_1accounts_ida'].includes(data.field)) {
            this.updateVisibilityRelations(sAction, data.prefix, data.field, data.value.id);
        }
    }

    // allows only one field between Account and Contact to be filled, one of the two field is required to be filled
    updateVisibilityRelations(sAction, prefix, field, value) {
        sAction.dataSet(`${prefix}/fields/${field}/value`, value);
        const contact = !!sAction.dataGet(prefix + '/fields/contacts_aon_portal_messages_visibility_1contacts_ida/value');
        const account = !!sAction.dataGet(prefix + '/fields/accounts_aon_portal_messages_visibility_1accounts_ida/value');

        console.log(contact, account);

        sAction.dsClear();
        sAction.dsAdd('set', prefix + '/fields/contacts_aon_portal_messages_visibility_1_name/def/readonly', account);
        sAction.dsAdd('set', prefix + '/fields/contacts_aon_portal_messages_visibility_1_name/def/required', !account);
        sAction.dsAdd('set', prefix + '/fields/accounts_aon_portal_messages_visibility_1_name/def/readonly', contact);
        sAction.dsAdd('set', prefix + '/fields/accounts_aon_portal_messages_visibility_1_name/def/required', !contact);
        sAction.dsProcess();
    }
}
